"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doordashIcons = exports.caviarIcons = exports.availableTypes = exports.currentIconSubdirectoryName = void 0;

var _iconSemantics = require("./caviar/icon/icon-semantics");

var _iconSemantics2 = require("./default/icon/icon-semantics");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var currentIconSubdirectoryName = '2021-05-07T00:35:11.878Z';
exports.currentIconSubdirectoryName = currentIconSubdirectoryName;
var availableTypes = {
  Caviar: _objectSpread({}, _iconSemantics.availableTypes),
  DoorDash: _objectSpread({}, _iconSemantics2.availableTypes)
};
exports.availableTypes = availableTypes;

var caviarIcons = _objectSpread({}, _iconSemantics.availableAssets);

exports.caviarIcons = caviarIcons;

var doordashIcons = _objectSpread({}, _iconSemantics2.availableAssets);

exports.doordashIcons = doordashIcons;